import { routes as appViews } from "./views/app-views";
import { routes as auth } from "./views/auth";
import { routes as welcome } from "./views/welcome";
import { routes as paymethod } from "./views/paymethod";
import { routes as orders } from './views/orders';
import { routes as subscriptions } from './views/subs';
import { routes as noservice } from './views/noservice';
import { routes as addresses } from './views/address';
import { routes as contact } from './views/contact';
import { routes as admin } from './views/admin';
import { routes as messages } from './views/inbox';

export const routes = [ 
  ...appViews,
  ...welcome,
  ...orders,
  ...addresses, 
  ...paymethod,
  ...subscriptions,
   ...noservice,
  ...contact,
    ...admin,
    ...messages
];

export const authRoutes = [
  ...auth
];
